<footer class="new_footer_area bg_color">
    <div class="new_footer_top">
        <div class="container">
            <div class="row">
                <div class="col-lg-3 col-md-6 col-sm-12">
                    <div class="f_widget company_widget wow fadeInLeft" data-wow-delay="0.2s"
                        style="visibility: visible; animation-delay: 0.2s; animation-name: fadeInLeft;">
                        <h3 class="f-title mb-4">
                            <img src="/assets/img/logo/logo2.png" alt="Logo" id="logo" class="img-fluid">
                        </h3>
                        <p class="text-uppercase"><i class="fa-solid fa-location-dot"></i> Shah Satnam Ji Girls'
                            College Near Shah Satnam Ji Speciality Hospital Bhadra, Road, Sirsa, Haryana 125055</p>
                        <p><i class="fa-regular fa-envelope"></i> ssji1525@gmail.com <br>
                            ssgians1@gmail.com</p>
                        <p><i class="fa-solid fa-phone"></i> +91 9728338602</p>
                        <p><i class="fa-solid fa-phone"></i> +91 9053338602</p>
                        <!-- <div class="visitor-badge"><i class="fa-regular fa-eye"></i> Total Visitors: {{count}}</div> -->
                    </div>
                </div>
                <div class="col-lg-3 col-md-6 col-sm-12">
                    <div class="f_widget about-widget wow fadeInLeft" data-wow-delay="0.4s"
                        style="visibility: visible; animation-delay: 0.4s; animation-name: fadeInLeft;">
                        <h3 class="f-title f_600 t_color f_size_18">Quick Link</h3>
                        <ul class="list-unstyled f_list">
                            <li><a routerLink="/academics/programs"><i
                                        class="fa-solid fa-angle-right me-2 link-icon"></i>Courses</a></li>
                            <li><a routerLink="/awards"><i class="fa-solid fa-angle-right me-2 link-icon"></i>Academic
                                    Gems</a></li>
                            <li><a routerLink="/contact-us"><i
                                        class="fa-solid fa-angle-right me-2 link-icon"></i>Contact Us</a></li>
                            <li><a routerLink="/research/rd-cell"><i
                                        class="fa-solid fa-angle-right me-2 link-icon"></i>R&amp;D Cell</a></li>
                            <li><a routerLink="/mous"><i class="fa-solid fa-angle-right me-2 link-icon"></i>Industry
                                    Collaboration (MoUs)</a></li>
                            <li><a routerLink="/research/incubation"><i
                                        class="fa-solid fa-angle-right me-2 link-icon"></i>Incubation Centre</a></li>
                        </ul>
                    </div>
                </div>
                <div class="col-lg-3 col-md-6 col-sm-12">
                    <div class="f_widget about-widget wow fadeInLeft" data-wow-delay="0.6s"
                        style="visibility: visible; animation-delay: 0.6s; animation-name: fadeInLeft;">
                        <h3 class="f-title f_600 t_color f_size_18">Explore</h3>
                        <ul class="list-unstyled f_list">
                            <li><a routerLink="/admissions/prospectus"><i
                                        class="fa-solid fa-angle-right me-2 link-icon"></i>Prospectus</a></li>
                            <li><a routerLink="/academics/calendar"><i
                                        class="fa-solid fa-angle-right me-2 link-icon"></i>Academic Calendar</a></li>
                            <li><a routerLink="/academics/time-table"><i
                                        class="fa-solid fa-angle-right me-2 link-icon"></i>Time Tables</a></li>
                            <li><a routerLink="/gallery"><i
                                        class="fa-solid fa-angle-right me-2 link-icon"></i>Gallery</a></li>
                            <li><a href="/assets/pdf/lms-learning.pdf" target="_blank"><i
                                        class="fa-solid fa-angle-right me-2 link-icon"></i>LMS Online Learning</a></li>
                        </ul>
                    </div>
                </div>
                <div class="col-lg-3 col-md-6 col-sm-12">
                    <div class="f_widget social-widget wow fadeInLeft" data-wow-delay="0.8s"
                        style="visibility: visible; animation-delay: 0.8s; animation-name: fadeInLeft;">
                        <h3 class="f-title f_600 t_color f_size_18">Social Links</h3>
                        <div class="f_social_icon">
                            <a href="https://www.facebook.com/shahsatnamjigirlscollegesirsa/" class="fab fa-facebook"
                                target="_blank"></a>

                            <a href="https://www.instagram.com/shahsatnamjigirlscollegesirsa?igsh=MW9veGtwc3d2ZDlpNA=="
                                class="fab fa-instagram" target="_blank"></a>
                            <a href="https://share.google/ZV5w2ThpVrjKGe8H5" class="fab fa-threads" target="_blank"></a>
                            <a href="https://maps.app.goo.gl/xnt7C9SafCdcE7g78" class="fa-solid fa-map-pin"
                                target="_blank"></a>
                            <a href="https://www.youtube.com/channel/UCZSxE3ywZQA_xXVbNP3vSFw"
                                class="fa-brands fa-youtube" target="_blank"></a>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="footer_bg">
            <div class="footer_bg_one"></div>
            <div class="footer_bg_two"></div>
        </div>
    </div>
    <div class="footer_bottom">
        <div class="container">
            <div class="row align-items-center">
                <div class="col-lg-12 col-sm-12">
                    <p class="mt-3 mt-md-0"><a href="https://okiedokiepay.com/" target="_blank">Crafted with ❤️ by Okie
                            Dokie </a>
                        <br>
                        <a href="https://okiedokiepay.com/" target="_blank">Haryana's No. 1 Campus Automation
                            Partner</a>
                    </p>
                </div>
            </div>
        </div>
    </div>
</footer>